<tt-page>
    <div class="col-xs-12 sp-0" *ngIf="'mobile' | mediaQuery">
        <tt-card *ngIf="!!setting">
            <tt-input ttLabel="currencytype_name" [(ttModel)]="setting.currencytype_name" ttReadonly></tt-input>
        </tt-card>

        <tt-list-legacy [listItems]="itemsListCurrencyExRates" ltype="multi" typevar="g"></tt-list-legacy>
    </div>

    <div *ngIf="['tablet', 'laptop', 'desktop'] | mediaQuery">
        <tt-divider ttRememberId="currencyexrates_dividers">
            <tt-divider-columns>
                <tt-divider-pane ttSize="30">
                    <tt-card *ngIf="!!setting">
                        <tt-input ttLabel="currencytype_name" [(ttModel)]="setting.currencytype_name" ttReadonly></tt-input>
                    </tt-card>
                </tt-divider-pane>

                <tt-divider-pane ttSize="70">
                    <tt-list-legacy [listItems]="itemsListCurrencyExRates" ltype="multi" typevar="g"></tt-list-legacy>
                </tt-divider-pane>
            </tt-divider-columns>
        </tt-divider>
    </div>
</tt-page>
